import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import { Select2Data } from "../../../utils/common";
import JoditEditor from "jodit-react";
import { logDOM } from "@testing-library/react";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/cab-type/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    setValue,
    watch,
    getValues,
  } = useForm();
  const descriptionValue = watch("facilities");
  useEffect(() => {
    register("facilities", {
      required: "Facilities is required.",
    });
  }, [register]);
  const featuresAndAminitiesValue = watch("long_description");
  useEffect(() => {
    register("long_description", {
      required: "view More is required.",
    });
  }, [register]);

  const includedValue = watch("included");
  useEffect(() => {
    register("included", {
      required: "Included is required.",
    });
  }, [register]);
  const excludedValue = watch("excluded");
  useEffect(() => {
    register("excluded", {
      required: "Excluded is required.",
    });
  }, [register]);

  const imageFile = watch("image");

  const Select3Data = async (dataArray, name, includeOther = false) => {
    const result = dataArray.map((item) => ({
      value: item?.id,
      label: `${item?.hour}Hr-${item?.kilometer}Km`,
      name: name,
    }));

    if (includeOther) {
      result.push({ value: "0", label: "Other", name: name });
    }

    return result;
  };

  const [fuelType, setFuelType] = useState([]);
  const GetAllFuelType = async () => {
    const response = await getData("/allfuel-type");

    if (response?.success) {
      setFuelType(await Select2Data(response?.data, "fuel_type_id"));
    }
  };

  const [seatCapacity, setSeatCapacity] = useState([]);

  const GetAllSeatCapacity = async () => {
    const response = await getData("/allseat-capacity");

    if (response?.success) {
      setSeatCapacity(await Select2Data(response?.data, "seat_capacity_id"));
    }
  };
  useEffect(() => {
    GetAllFuelType();
    GetAllSeatCapacity();
  }, []);
  const onSubmit = async (data) => {
    try {
      const langPayload = countLang.map((lang) => ({
        language_id: lang.id,
        name: data[lang.id],
      }));

      // Create FormData
      const formData = new FormData();

      // Append file (image)
      if (data.image && data.image[0]) {
        formData.append("image", data.image[0]); // file input
      }

      // Append other common fields
      formData.append(
        "seat_capacity_id",
        data.seat_capacity_id?.value || data.seat_capacity_id
      );
      formData.append(
        "fuel_type_id",
        data.fuel_type_id?.value || data.fuel_type_id
      );

      // Append languages array as JSON string
      formData.append("languages", JSON.stringify(langPayload));
      const response = await postData(`/masters/cab-type/${id}`, formData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [countLang, setCountLang] = useState([]);

  const getLanguges = async () => {
    const response = await getData("/all-languages");
    setCountLang(response.data);
  };

  useEffect(() => {
    getLanguges();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Cab Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="">
              {countLang?.map((lang, index) => (
                <Col md={12} key={lang.id}>
                  <div className="main-form-section mt-5">
                    <Row className="justify-content-center">
                      <Form.Label column sm={3}>
                        Cab Type ({lang?.name})
                      </Form.Label>
                      <Col sm={6}>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              type="text"
                              placeholder={`Enter Cab Type in ${lang?.name}`}
                              className="input-mandatory"
                              {...register(`${lang.id}`, {
                                required: `Cab Type is required in ${lang.name}`,
                              })}
                            />
                          </InputGroup>
                          {errors[lang.id] && (
                            <span className="text-danger">
                              {errors[lang.id].message}
                            </span>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Driver Payment(per day)</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        min={1}
                        name="driver_payment"
                        placeholder="Driver Payment"
                        className={classNames("", {
                          "is-invalid": errors?.driver_payment,
                        })}
                        {...register("driver_payment", {
                          required: "Driver Payment is required",
                          validate: (value) =>
                            value > 0 || "Fare must be greater than 0",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E" ||
                            (isNaN(Number(e.key)) &&
                              e.key !== "Backspace" &&
                              e.key !== "Tab" &&
                              e.key !== ".") || // Allow decimal point
                            (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pasteData)) {
                            // Allow only numbers with optional single decimal
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>
                    {errors.driver_payment && (
                      <span className="text-danger">
                        {errors.driver_payment.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Sort Order</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        min={1}
                        name="sort_order"
                        placeholder="Sort Order"
                        className={classNames("", {
                          "is-invalid": errors?.sort_order,
                        })}
                        {...register("sort_order", {
                          required: "Sort order is required",
                          validate: (value) =>
                            value > 0 || "Fare must be greater than 0",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E" ||
                            (isNaN(Number(e.key)) &&
                              e.key !== "Backspace" &&
                              e.key !== "Tab" &&
                              e.key !== ".") || // Allow decimal point
                            (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pasteData)) {
                            // Allow only numbers with optional single decimal
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>
                    {errors.sort_order && (
                      <span className="text-danger">
                        {errors.sort_order.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Cab Name</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Cab Name"
                          className={classNames("", {
                            "is-invalid": errors?.cab_name,
                          })}
                          {...register("cab_name", {
                            required: "cab Name is required",
                          })}
                        />
                      </InputGroup>
                      {errors.cab_name && (
                        <span className="text-danger">
                          {errors.cab_name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Seat Capacity</Form.Label>
                    <Controller
                      name="seat_capacity_id" // name of the field
                      {...register("seat_capacity_id", {
                        required: "Select Seat Capacity",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.seat_capacity_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={seatCapacity}
                        />
                      )}
                    />
                    {errors.seat_capacity_id && (
                      <span className="text-danger">
                        {errors.seat_capacity_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Fuel Type</Form.Label>
                    <Controller
                      name="fuel_type_id" // name of the field
                      {...register("fuel_type_id", {
                        required: "Select Fuel Type",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.fuel_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={fuelType}
                        />
                      )}
                    />
                    {errors.fuel_type_id && (
                      <span className="text-danger">
                        {errors.fuel_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Cancellation</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="cancellation"
                          placeholder="cancellation"
                          className={classNames("", {
                            "is-invalid": errors?.cancellation,
                          })}
                          {...register("cancellation", {
                            required: "cancellation is required",
                          })}
                        />
                      </InputGroup>
                      {errors.cancellation && (
                        <span className="text-danger">
                          {errors.cancellation.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Facilities</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="facilities"
                          placeholder="Facilities"
                          className={classNames("", {
                            "is-invalid": errors?.facilities,
                          })}
                          {...register("facilities", {
                            required: "Facilities is required",
                          })}
                        />
                      </InputGroup>
                      {errors.facilities && (
                        <span className="text-danger">
                          {errors.facilities.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label> Image</Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        type="file"
                        {...register("image", {
                          validate: async (value) => {
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                        multiple={false}
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview </Form.Label>

                    {typeof getValues("image") == "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container mt-3">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col>

              {/* <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Col sm={12}>
                      <Form.Label className="text-center">View More</Form.Label>
                      <Form.Group>
                        <Controller
                          name="long_description" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: " Long Description is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={featuresAndAminitiesValue || ""}
                              onBlur={(newContent) => {
                                setValue("long_description", newContent);
                                trigger("long_description");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.long_description && (
                        <span className="text-danger">
                          {errors.long_description.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}
                
                    <Col sm={12}>
                      <Form.Label className="text-center">Included</Form.Label>
                      <Form.Group>
                        <Controller
                          name="included" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "included is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={includedValue || ""}
                              onBlur={(newContent) => {
                                setValue("included", newContent);
                                trigger("included");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.included && (
                        <span className="text-danger">
                          {errors.included.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    <Col sm={12}>
                      <Form.Label className="text-center">Excluded</Form.Label>
                      <Form.Group>
                        <Controller
                          name="excluded" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: " excluded is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={excludedValue || ""}
                              onBlur={(newContent) => {
                                setValue("excluded", newContent);
                                trigger("excluded");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.excluded && (
                        <span className="text-danger">
                          {errors.excluded.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
